<template>

  <nav class="c-nav" :class="$route.name === 'Home' ? 'c-nav__splash' : ''" v-if="type">
    <ul class="c-nav__list">
      <template v-for="(item, index) in $globals.navigation.menu">
        <li class="c-nav__item" v-if="item.hideOn !== type" :key="index">
            <a v-if="item.target === '_blank'" class="c-nav__link" target="_blank" :href="item.link">{{ item.text }}</a>
            <router-link v-else class="c-nav__link" :to="`/${$route.params.lang}/${item.link}`">{{ item.text }}</router-link>
        </li>
      </template>
    </ul>
  </nav>

</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Navigation',

  computed: {
    ...mapState({
        type: state => state.type
    })
  }

}
</script>
